import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SR_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#SR_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 16h32v8H0v-8zM0 0h32v6H0V0z",
      fill: "#4E8B1D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M0 6.5h-1.5v11h35v-11H0z",
      fill: "#AF0100",
      stroke: "#fff",
      strokeWidth: 3
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.002 14.494L13.508 16l.57-2.938-2.078-2.2 2.813-.118L16.003 8l1.19 2.744H20l-2.072 2.318.624 2.938-2.55-1.506z",
      fill: "#FECA00"
    }
  ))
), a = t;
export {
  a as default
};
